import React from 'react';

export function Container({ children, maxWidth = "lg", className = "" }) {
  const maxWidthClasses = {
    sm: "max-w-2xl",
    md: "max-w-4xl", 
    lg: "max-w-6xl",
    xl: "max-w-7xl",
  };

  return (
    <div className={`${maxWidthClasses[maxWidth]} mx-auto px-4 ${className}`}>
      {children}
    </div>
  );
}

export function Grid({ children, cols = 1, gap = 4, className = "" }) {
  const colClasses = {
    1: "grid-cols-1",
    2: "grid-cols-1 md:grid-cols-2",
    3: "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
    4: "grid-cols-1 md:grid-cols-2 lg:grid-cols-4",
    6: "grid-cols-2 md:grid-cols-3 lg:grid-cols-6",
  };

  const gapClasses = {
    2: "gap-2",
    3: "gap-3", 
    4: "gap-4",
    6: "gap-6",
    8: "gap-8",
  };

  return (
    <div className={`grid ${colClasses[cols]} ${gapClasses[gap]} ${className}`}>
      {children}
    </div>
  );
}

export function GridItem({ children, span = 1, className = "" }) {
  const spanClasses = {
    1: "col-span-1",
    2: "col-span-2", 
    3: "col-span-3",
    4: "col-span-4",
    6: "col-span-6",
    12: "col-span-12",
  };

  return (
    <div className={`${spanClasses[span]} ${className}`}>
      {children}
    </div>
  );
}

export function PageLayout({ children, className = "" }) {
  return (
    <div className={`min-h-screen bg-gradient-main ${className}`}>
      {children}
    </div>
  );
} 